import React, { FunctionComponent } from 'react'
import {
  ContentSection,
  Callout,
  Paragraph,
  Button,
  ButtonContainer,
  Spinner,
} from '@vwfs-bronson/bronson-react'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import routes from '../../routes'
import { history } from '../../services/routing'
import { getQuestionnaireUrl } from '../../services/api/customer-happiness-index'

interface CHIProps {}

const CHI: FunctionComponent<CHIProps> = () => {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = React.useState(false)

  const goToQuestionnaireUrl = async () => {
    setIsLoading(true)
    try {
      const data = await getQuestionnaireUrl()
      if (data?.custom?.redirectUrl) {
        window.open(data?.custom?.redirectUrl, '_blank')
      }
    } catch {
      history.push(routes.errorPage)
    } finally {
      setIsLoading(false)
    }
  }

  const onConfirm = () => {
    goToQuestionnaireUrl()
  }

  const buildCHILink = (text, href, separator = '') => (
    <>
      <a href={href} target="_blank" rel="noopener noreferrer">
        {text}
      </a>
      {separator}
    </>
  )

  // eslint-disable-next-line global-require
  const imageCHI = require('../../resources/images/imagesCHI/CHI--bluelabel.png')
  const footerLinks = t('chi:legal:links', { returnObjects: true});

  return (
    <>
      {isLoading && <Spinner fullPage />}
      <ContentSection className="u-p-none">
        <Callout
          media={{
            alt: 'Customer Happiness Index icon',
            sizes: '30%',
            src: imageCHI,
          }}
          title={t('chi:title')}
        >
          <Paragraph>{t('chi:text')}</Paragraph>
          <ButtonContainer className="u-mt" center>
            <Button onClick={onConfirm}>{t('chi:button')}</Button>
          </ButtonContainer>
        </Callout>
      </ContentSection>
      <ContentSection pageWrap className="u-pv-small">
        <Paragraph className="c-footnotes">
          {t('chi:legal:text')}
          {footerLinks?.map((link: any, index: number) => {
            return buildCHILink(link.text, link.url, index === footerLinks?.length - 1  ? '' : ', ');
          })}
          .
        </Paragraph>
      </ContentSection>
    </>
  )
}

const mapStateToProps = (state) => {
  return {}
}

export default connect(mapStateToProps)(CHI)
